import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { EnumService } from '../../../core/enum.service';
import { ModalService } from '../../../core/modal.service';

@Component({
  selector: 'app-step7',
  templateUrl: './step7.component.html'
})
export class Step7Component implements OnInit, OnChanges {
  @Input() product: any = {};
  @Input() productDetailMode: boolean;
  @Input() readonly = false;
  @ViewChild('form') form;
  longevity: any[] = [];
  markets: boolean;
  column = 'uk-width-1-1';

  constructor(private enumService: EnumService, private modalService: ModalService) {}

  ngOnInit() {
    this.longevity = this.enumService.getLongevityTypes();
  }

  ngOnChanges() {
    if (this.product.wineTechnical.markets) {
      this.markets = true;
    }

    if (this.productDetailMode) {
      this.column = 'uk-width-small-1-2';
    }
  }

  isValid() {
    return this.form.valid;
  }

  validate() {
    this.form.submitted = true;
    if (!this.isValid()) {
      this.modalService.showFormError();
      return false;
    }
    return true;
  }

  getData() {
    return this.product;
  }

  addProductImage($event: any) {
    this.product.image = $event;
  }
}
